import { isCurrentMemberOrgAdmin, isCurrentUserStaffOrSuperAdmin } from 'common/selectors/auth';
import { BodyText, H4, PageSection, Title } from 'common/styles/page';
import React from 'react';
import { useSelector } from 'react-redux';
import { Icon, Modal } from 'semantic-ui-react';
import styled from 'styled-components';

interface OrganizationGoalDetailsModalProps {
  title: string;
  details: string;
  context: any;
  handleCloseModal: () => void;
  isModalOpen: boolean;
}

const OrganizationGoalDetailsModal: React.FC<OrganizationGoalDetailsModalProps> = ({
  title,
  details,
  context,
  handleCloseModal,
  isModalOpen,
}) => {
  const isUserAdmin = useSelector(isCurrentUserStaffOrSuperAdmin);
  const isUserOrgAdmin = useSelector(isCurrentMemberOrgAdmin);

  if (!context || !title) {
    return <></>;
  }

  return (
    <Modal open={isModalOpen} onClose={handleCloseModal} size="small">
      <Modal.Header>
        <PageSection display="flex" flexDirection="row" justifyContent="space-between">
          <Title>{title}</Title>
          <CloseIcon name="close" onClick={handleCloseModal} />
        </PageSection>
      </Modal.Header>

      <Modal.Content>
        <>
          <H4>Primary Goal</H4>
          <BodyText padbottom>{details}</BodyText>

          {context.recommendationQuestion && (
            <>
              <H4>Problem to Solve</H4>
              <BodyText padbottom>{context.recommendationQuestion}</BodyText>
            </>
          )}
          {context.recommendationQuestion && (
            <>
              <H4>Why This Recommendation?</H4>
              <BodyText padbottom>{context.whyRecommendation}</BodyText>
            </>
          )}

          {(isUserOrgAdmin || isUserAdmin) && (
            <>
              <PageSection display="flex" flexDirection="row">
                <PageSection display="flex" flexDirection="column" width="50%">
                  {context.effortRequires && (
                    <>
                      {context.effortRequires.length > 0 && (
                        <>
                          <H4>Effort Requires</H4>
                          <StyledList>
                            {context.effortRequires.map((effort: string, index: number) => (
                              <li key={index}>
                                <BodyText>{effort}</BodyText>
                              </li>
                            ))}
                          </StyledList>
                        </>
                      )}
                    </>
                  )}
                </PageSection>
                <PageSection display="flex" flexDirection="column" width="50%">
                  {context.effortRequires && (
                    <>
                      {context.organizationQuestions.length > 0 && (
                        <>
                          <H4>Organization Questions</H4>
                          <StyledList>
                            {context.organizationQuestions.map((effort: string, index: number) => (
                              <li key={index}>
                                <BodyText>{effort}</BodyText>
                              </li>
                            ))}
                          </StyledList>
                        </>
                      )}
                    </>
                  )}
                </PageSection>
              </PageSection>
            </>
          )}

          {context.focusAreas && (
            <>
              <H4>Focus Areas</H4>
              <BodyText padbottom>{context.focusAreas}</BodyText>
            </>
          )}

          {(isUserOrgAdmin || isUserAdmin) && (
            <>
              <PageSection display="flex" flexDirection="row">
                <PageSection display="flex" flexDirection="column" width="50%">
                  {context.policyChange && (
                    <>
                      <H4>Policy Changes</H4>
                      <BodyText padbottom>{context.policyChange}</BodyText>
                    </>
                  )}
                  {context.primaryStakeholder && (
                    <>
                      <H4>Primary Stakeholder</H4>
                      <BodyText padbottom>{context.primaryStakeholder}</BodyText>
                    </>
                  )}
                  {context.timeframe && (
                    <>
                      <H4>Timeframe</H4>
                      <BodyText padbottom>{context.timeframe}</BodyText>
                    </>
                  )}
                  {context.dataCollection && (
                    <>
                      <H4>Data Collection</H4>
                      <BodyText padbottom>{context.dataCollection}</BodyText>
                    </>
                  )}
                </PageSection>

                <PageSection display="flex" flexDirection="column" width="50%">
                  {context.cultureChange && (
                    <>
                      <H4>Culture Changes</H4>
                      <BodyText padbottom>{context.cultureChange}</BodyText>
                    </>
                  )}
                  {context.communityConnections && (
                    <>
                      <H4>Community Connections</H4>
                      <BodyText padbottom>{context.communityConnections}</BodyText>
                    </>
                  )}
                  {context.cost && (
                    <>
                      <H4>Cost</H4>
                      <BodyText padbottom>{context.cost}</BodyText>
                    </>
                  )}
                  {context.involvedAreas && (
                    <>
                      <H4>Involved Areas</H4>
                      <BodyText padbottom>{context.involvedAreas}</BodyText>
                    </>
                  )}
                </PageSection>
              </PageSection>
            </>
          )}

          {context.desiredOutcome && (
            <>
              <H4>Desired Outcomes</H4>
              <BodyText padbottom>{context.desiredOutcome}</BodyText>
            </>
          )}
        </>
      </Modal.Content>
    </Modal>
  );
};
export default OrganizationGoalDetailsModal;

const StyledList = styled.ul`
  margin: 0;
  padding-top: 0px;
  padding-left: 20px;
`;

const CloseIcon = styled(Icon as any)`
  cursor: pointer;
  font-size: 1.2rem;
  &:hover {
    opacity: 0.7;
  }
`;
